/*
 * @Author: lidan
 * @Date: 2020-12-30 11:39:42
 * @LastEditTime: 2021-01-20 10:38:55
 * @LastEditors: lidan
 * @Description: 电子围栏配送设置api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\fenceDeliverySettings.js
 */

import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 电子围栏配送设置 ****************** */

// 获取电子围栏配送设置列表数据
export function findByPageElectronic(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/findByPage`,
    method: "post",
    data
  });
}

// 新增电子围栏配送设置
export function saveElectronic(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/insert`,
    method: "post",
    data
  });
}

// 修改电子围栏配送设置
export function updateElectronic(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/update`,
    method: "post",
    data
  });
}

// 根据ID获取电子围栏配送设置详情
export function findByIdElectronic(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/findById`,
    method: "get",
    params
  });
}

// 根据ID获取电子围栏配送设置详情
export function deleteElectronic(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/delete`,
    method: "post",
    data
  });
}

// 导出电子围栏配送设置
export function exportElectronic(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/export`,
    method: "post",
    data
  });
}

// 电子围栏配送设置历史记录
export function findHistoryByPageElectronic(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/config/findHistoryByPage`,
    method: "post",
    data
  });
}

//获取所属片区下拉数据
export function findBoxPiece(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/piece/findBox`,
    method: "post",
    data
  });
}
